import React, { useRef } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import './kernelSearch.css';

/**
 * Campo di ricerca con lente e, finché c'è del testo, una x in fondo per cancellarlo
 * (rimette il cursore nel campo). `onChange` riceve direttamente il testo.
 */
function KernelSearchBox({ value, onChange, placeholder, title, className = '' }) {
  const { t } = useLanguage();
  const inputRef = useRef(null);

  return (
    <label className={`ksb ${className}`.trim()} title={title}>
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="11" cy="11" r="7" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input
        ref={inputRef}
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
      />
      {value !== '' && (
        <button
          type="button"
          className="ksb-clear"
          title={t('common.clearSearch')}
          aria-label={t('common.clearSearch')}
          onClick={(e) => {
            e.preventDefault();
            onChange('');
            inputRef.current?.focus();
          }}
        >
          ×
        </button>
      )}
    </label>
  );
}

export default KernelSearchBox;
